const BaseModule = require('../../90_utils/base/BaseModule');
const CursorZoom = require('../cursor-zoom/script');

class WigglePhoto extends BaseModule {

	constructor(el, $img, $container, $mouseTarget, bleedFactor) {

		super(el);

		//


		this.$img = this.checkVals([$img, this.$el.find('figure')]);
		this.$container = this.checkVals([$container, this.$el]);
		this.$mouseTarget = this.checkVals([$mouseTarget, this.$el]);
		this.bleedFactor = this.checkVals([bleedFactor, parseFloat(this.$el.attr('data-bleed-factor'))], 0.25);

		//

		this._frameStep;
		this._cursor = null;
	}

	//

	_addListeners(){

		super._addListeners();

		//

		this.$mouseTarget.on('mouseenter', this._onPhotoOver.bind(this));
		this.$mouseTarget.on('mouseleave', this._onPhotoOut.bind(this));

		if(!this._cursor){

			let $cursor = this.$el.find('[data-cursor-zoom]');

			if($cursor.length){

				this.$container.on('mouseenter', this._onContainerOver.bind(this));
				this.$container.on('mouseleave', this._onContainerOut.bind(this));

				this._cursor = new CursorZoom($cursor, this.$el);
			}
		}
		else { this._cursor.enable(); }
	}

	_removeListeners(){

		super._removeListeners();

		//

		this.$mouseTarget.off('mouseenter', this._onPhotoOver.bind(this));
		this.$mouseTarget.off('mouseleave', this._onPhotoOut.bind(this));

		if(this._cursor){ this._cursor.enable(); }
	}

	//

	_onPhotoOver(){
		this.enable();
	}

	_onPhotoOut(){
		this.disable();
	}

	//

	_onContainerOver(){
		this._cursor.enable();
	}

	_onContainerOut(){
		this._cursor.disable();
	}

	//

	enable(){

		super.enable();

		this._tick(true); // start loop
		this.$el.addClass('is-wiggling');
	}

	disable(){

		super.disable();

		this._frameStep = false; // kill loop
		this.$el.removeClass('is-wiggling');

		TweenMax.set(this.$img, {clearProps:'x, y, scale, force3D'});
	}

	//

	_tick(frameStep){

		if(typeof(frameStep) === 'boolean'){ this._frameStep = frameStep; }

		if(this._frameStep){
			this._wiggle();
			window.requestAnimationFrame(this._tick.bind(this, null));
		}
	}

	_wiggle(){

		if(this.$img && this.$img.length){

			let boundingRect = this.$img[0].getBoundingClientRect();
			let bleed = Math.min(boundingRect.width - this.$el.width(), boundingRect.height - this.$el.height())/(2/this.bleedFactor);

			let clientX = window.SETTINGS.coords.clientX;
			let clientY = window.SETTINGS.coords.clientY;
			let xRatio = (clientX - (boundingRect.left + boundingRect.width/2))/(boundingRect.width/2);
			let yRatio = (clientY - (boundingRect.top + boundingRect.height/2))/(boundingRect.height/2) + 0.3;

			if(!isNaN(xRatio) && !isNaN(yRatio)){
				TweenMax.set(this.$img, {x:0 - Math.round(xRatio * bleed), y:0 - Math.round(yRatio * bleed), force3D:true});
			}
		}
	}

	//
}

module.exports = WigglePhoto;
